import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";

import AccountModal from "@/account/components/shared/account-modal.vue";
import LoginContent from "@/account/components/login/login-content.vue";
import useAuthenticationFlows, { authenticationStep } from "../composables/use-authentication-flows";


export default /*@__PURE__*/_defineComponent({
  __name: 'login-modal',
  setup(__props) {

const { closeAccountModal } = useAuthenticationFlows();

const isLoginOpened = computed(
    () =>
        authenticationStep.value == "LoginWelcome" ||
        authenticationStep.value == "LoginPass" ||
        authenticationStep.value == "LoginPhone" ||
        authenticationStep.value == "ForgPinGen" ||
        authenticationStep.value == "ForgPinLog" ||
        authenticationStep.value == "ForgPinOk" ||
        authenticationStep.value == "ForgNewPass" ||
        authenticationStep.value == "ForgNewPassOk"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccountModal, {
    modelValue: isLoginOpened.value,
    "onUpdate:modelValue": _unref(closeAccountModal),
    class: "login-modal"
  }, {
    default: _withCtx(() => [
      _createVNode(LoginContent)
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
}

})